import { Link, useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "../../css/Manage.css";
import "../../css/accomodation/ManageAccomodationEdit.css";
import AccomodationApi from "../../api/accomodationApi";
import RoomApi from "../../api/roomApi";
import { toast } from "react-toastify";
import { Map, MapMarker } from "react-kakao-maps-sdk";
import ManageAccomodationRoomAdd from "./ManageAccomodationRoomAdd";

const ManageAccomodationEdit = () => {
  let navigate = useNavigate();
  let location = useLocation();

  const [accomodationId, setAccomodationId] = useState(null);
  const [accomodationInfo, setAccomodationInfo] = useState({});
  const [addRoomPopupFlag, setAddRoomPopupFlag] = useState(false);

  useEffect(() => {
    if (location.state) {
      const { id } = location.state;
      setAccomodationId(location.state.id);
      getAccomodationInfo(id);
    }
  }, [location]);

  const getAccomodationInfo = async (id) => {
    try {
      const info = (await AccomodationApi.GetAccomodation(id)).data.data
        .content;
      setAccomodationInfo((accomodationInfo) => ({
        ...accomodationInfo,
        ...info,
        imageDeleteFlag: false,
      }));
    } catch (error) {
      console.log(error);
      toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요.");
    }
  };

  const accomodationImg = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      setAccomodationInfo((accomodationInfo) => ({
        ...accomodationInfo,
        image: file,
        imageUrl: e.target.result,
        imageDeleteFlag: true,
      }));
    };
    reader.readAsDataURL(file);
    e.target.value = "";
  };

  const deleteImage = () => {
    setAccomodationInfo((accomodationInfo) => ({
      ...accomodationInfo,
      image: null,
      imageUrl: "",
      imageDeleteFlag: true,
    }));
  };

  const accomodationEdit = async () => {
    if (!accomodationInfo.name) {
      toast("숙소명을 입력해주세요");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("name", accomodationInfo.name);
      formData.append("companyName", accomodationInfo.companyName);
      formData.append("managerName", accomodationInfo.managerName);
      formData.append("phoneNumber", accomodationInfo.phoneNumber);
      formData.append("email", accomodationInfo.email);
      if (accomodationInfo.address) {
        formData.append("address", accomodationInfo.address);
      }
      if (accomodationInfo.addressDetail) {
        formData.append("addressDetail", accomodationInfo.addressDetail);
      }
      if (accomodationInfo.latitude) {
        formData.append("lat", accomodationInfo.latitude);
      }
      if (accomodationInfo.longitude) {
        formData.append("lon", accomodationInfo.longitude);
      }
      if (accomodationInfo.description) {
        formData.append("description", accomodationInfo.description);
      }
      if (accomodationInfo.imageDeleteFlag) {
        formData.append("image", accomodationInfo.image);
      }
      formData.append("imageDeleteFlag", accomodationInfo.imageDeleteFlag);

      await AccomodationApi.Patch(accomodationId, formData);
      toast("수정되었습니다.");
      navigate("/admin/accomodation");
    } catch (error) {
      console.log(error);
      if (error.response?.status === 413) {
        toast(`이미지 용량을 초과하였습니다.`);
      } else {
        toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요.");
      }
    }
  };

  const execDaumPostcode = () => {
    let geocoder = new window.kakao.maps.services.Geocoder();
    new window.daum.Postcode({
      oncomplete: (data) => {
        if (data.userSelectedType === "R") {
          // 사용자가 도로명 주소를 선택했을 경우
          geocoder.addressSearch(
            `${data.roadAddress}`,
            function (result, status) {
              // 정상적으로 검색이 완료됐으면
              if (status === window.kakao.maps.services.Status.OK) {
                setAccomodationInfo({
                  ...accomodationInfo,
                  address: data.roadAddress,
                  lat: result[0].y,
                  lon: result[0].x,
                });
              }
            }
          );
        } else {
          // 사용자가 지번 주소를 선택했을 경우(J)
          geocoder.addressSearch(
            `${data.roadAddress}`,
            function (result, status) {
              // 정상적으로 검색이 완료됐으면
              if (status === window.kakao.maps.services.Status.OK) {
                setAccomodationInfo({
                  ...accomodationInfo,
                  address: data.jibunAddress,
                  lat: result[0].y,
                  lon: result[0].x,
                });
              }
            }
          );
        }
      },
    }).open();
  };

  return (
    <div className="Manage-container">
      <section className="Manage-contents">
        <div className="go-back-container-accomodation-edit">
          <div
            className="go-back"
            onClick={() => {
              navigate(-1);
            }}
          >
            <Link>
              <img src="\img\chevron-left.svg" />
              <span>뒤로가기</span>
            </Link>
          </div>
        </div>
        <div className="Manage-form manage-form-accomodation-edit">
          <span>숙소 수정하기</span>
          <div>
            <span>기본정보</span>
            <div className="Manage-input-container Manage-input-container-accomodation-edit">
              <span className="Manage-input-title">숙소명*</span>
              <input
                className="Manage-input-textarea manage-form-accomodation-edit-input"
                type="text"
                placeholder="숙소명을 입력하세요"
                required
                value={accomodationInfo.name || ""}
                onChange={(e) => {
                  setAccomodationInfo((accomodationInfo) => ({
                    ...accomodationInfo,
                    name: e.target.value,
                  }));
                }}
              />
            </div>
            <div className="Manage-input-container Manage-input-container-accomodation-edit">
              <span className="Manage-input-title">주소*</span>
              <input
                className="Manage-input-textarea manage-form-accomodation-edit-input accomodation-edit-search-address"
                type="text"
                placeholder="주소를 입력하세요"
                value={accomodationInfo.address}
                required
                onClick={execDaumPostcode}
              />
            </div>
            <div className="Manage-input-container Manage-input-container-accomodation-edit">
              <span className="Manage-input-title">상세주소</span>
              <input
                className="Manage-input-textarea manage-form-accomodation-edit-input"
                type="text"
                placeholder="상세주소를 입력하세요"
                value={accomodationInfo.addressDetail}
                onChange={(e) => {
                  setAccomodationInfo((accomodationInfo) => ({
                    ...accomodationInfo,
                    addressDetail: e.target.value,
                  }));
                }}
              />
            </div>
            {accomodationInfo.latitude && accomodationInfo.longitude && (
              <div
                className="Manage-input-container Manage-input-container-accomodation-edit"
                style={{ alignItems: "start" }}
              >
                <span className="Manage-input-title">좌표*</span>
                <div>
                  <Map
                    center={{
                      lat: parseFloat(accomodationInfo.latitude),
                      lng: parseFloat(accomodationInfo.longitude),
                    }}
                    style={{
                      width: "366px",
                      height: "366px",
                      borderRadius: "4px",
                    }}
                    level={2}
                    maxLevel={3}
                  >
                    <MapMarker
                      position={{
                        lat: parseFloat(accomodationInfo.latitude),
                        lng: parseFloat(accomodationInfo.longitude),
                      }}
                      draggable={true}
                      onDragEnd={(e) => {
                        const lat = e.getPosition().getLat();
                        const lon = e.getPosition().getLng();
                        setAccomodationInfo({
                          ...accomodationInfo,
                          lat,
                          lon,
                        });
                      }}
                    />
                  </Map>
                  <div className="map-position-info">
                    <div>위도 (y좌표) : {accomodationInfo.latitude}</div>
                    <div>경도 (x좌표) : {accomodationInfo.longitude}</div>
                  </div>
                </div>
              </div>
            )}
            <div className="Manage-input-container manage-flex-start">
              <span className="Manage-input-title">이미지</span>
              <div className="accomodation-edit-input-file-container">
                <label htmlFor="image-file-input">
                  <img src="\img\file-upload-plus.svg" />
                  <span>파일 등록</span>
                </label>
                <input
                  id="image-file-input"
                  className="Manage-input-textarea manage-form-accomodation-edit-input"
                  type="file"
                  onChange={(e) => {
                    accomodationImg(e);
                  }}
                />
                {accomodationInfo.imageUrl ? (
                  <div className="accomodation-img">
                    <img
                      className="uploaded-img"
                      src={accomodationInfo?.imageUrl}
                    />
                    <img
                      className="accomodation-img-cancel cursorPointer"
                      src="\img\image-cancel.svg"
                      onClick={(e) => deleteImage()}
                    />
                  </div>
                ) : null}
              </div>
            </div>
            <div className="gathering-program-add-wrap">
              <span className="gathering-program-add">객실 등록</span>
              <div className="gathering-program-add-btn">
                <a
                  onClick={(e) => {
                    setAddRoomPopupFlag(true);
                  }}
                >
                  새로운 객실 추가
                </a>
              </div>
              {accomodationInfo.rooms && accomodationInfo.rooms.length > 0 && (
                <div style={{ marginTop: "20px" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr style={{ borderBottom: "1px solid #d7dbe0" }}>
                        <th style={{ padding: "10px", textAlign: "left" }}>
                          객실명
                        </th>
                        <th style={{ padding: "10px", textAlign: "left" }}>
                          가격
                        </th>
                        <th style={{ padding: "10px", textAlign: "left" }}>
                          이미지
                        </th>
                        <th style={{ padding: "10px", textAlign: "center" }}>
                          삭제
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {accomodationInfo.rooms.map((room, index) => (
                        <tr
                          key={index}
                          style={{ borderBottom: "1px solid #eef2f3" }}
                        >
                          <td style={{ padding: "10px" }}>{room.name}</td>
                          <td style={{ padding: "10px" }}>{room.price}원</td>
                          <td style={{ padding: "10px" }}>
                            {room.imageUrl && (
                              <img
                                src={room.imageUrl}
                                alt={room.name}
                                style={{
                                  width: "60px",
                                  height: "60px",
                                  objectFit: "cover",
                                  borderRadius: "4px",
                                }}
                              />
                            )}
                          </td>
                          <td style={{ padding: "10px", textAlign: "center" }}>
                            <button
                              className="cursorPointer"
                              style={{
                                padding: "5px 10px",
                                backgroundColor: "#ff4444",
                                color: "white",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                              }}
                              onClick={async () => {
                                if (
                                  window.confirm("이 객실을 삭제하시겠습니까?")
                                ) {
                                  try {
                                    await RoomApi.Del(room.id);
                                    toast("객실이 삭제되었습니다.");
                                    // Refresh accommodation info
                                    getAccomodationInfo(accomodationId);
                                  } catch (error) {
                                    toast("삭제에 실패했습니다.");
                                  }
                                }
                              }}
                            >
                              삭제
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
          <div className="Manage-form-save manage-form-save-accomodation-edit">
            <button className="cursorPointer" onClick={accomodationEdit}>
              저장하기
            </button>
          </div>
        </div>
      </section>

      <ManageAccomodationRoomAdd
        key={String(addRoomPopupFlag)}
        openFlag={addRoomPopupFlag}
        setAddRoomPopupFlag={setAddRoomPopupFlag}
        accomodationId={accomodationId}
        onRoomAdded={() => {
          // Refresh accommodation info to get updated rooms
          if (accomodationId) {
            getAccomodationInfo(accomodationId);
          }
        }}
      ></ManageAccomodationRoomAdd>
    </div>
  );
};

export default ManageAccomodationEdit;
